module.exports = __webpack_public_path__ + "static/semantic-icon-grouped-4269c8eba49ad92d6589e9aaaa3310f4.png";